<template>
  <div>
    <div
      class="text-center laptop:my-[30px] my-6 mobile:mt-[12px] mobile:mb-[40px] grid laptop:grid-cols-5 largeDesktop:grid-cols-5 mobile:grid-cols-1 items-start mobile:gap-3 laptop:gap-5 relative z-[2]">
      <div></div>
      <div class="laptop:col-span-3 text-center " :class="$route.name == 'workOrders' ? 'mb-[20px]' : ''">
        <h2
          class="mb-0 font-normal font-days !text-[22px] mobile:!text-[22px] largeDesktop:!text-[35px] mobile:px-[2rem] desktop:px-0">
          <template v-if="$route.name === 'plans'">
            <span class="text-[#F5B134]">My</span>
            <span class="text-[#2459A8]">HappyHome Protection Plans</span>
          </template>
          <template v-else-if="$route.name === 'purchases'">
            <span class="text-[#2459A8]">Purchased Plans</span>
          </template>
          <template v-else-if="$route.name === 'paymentMethod'">
            <span class="text-[#2459A8]">Billing History</span>
          </template>
          <template v-else-if="$route.name === 'paymentTransaction'">
            <span class="text-[#2459A8]">Billing History</span>
          </template>
          <template v-else-if="$route.name === 'claim'">
            <span class="text-[#2459A8]">Create Claim</span>
          </template>
          <template v-else>
            <span
              class="mb-0 font-normal font-days !text-[22px] mobile:!text-[25px] largeDesktop:!text-[35px] text-[#2459A8]">{{
                getHeading() }}</span>
          </template>
          <div v-if="$route.name === 'partnerCheckout' || $route.name === 'claim'"
            class="my-[10px] w-[100px] h-[2px] mx-auto bg-[#F5B134]"></div>
          <div v-else class="my-[10px] w-[150px] h-[2px] mx-auto bg-[#F5B134]"></div>
        </h2>
        <p class="mb-0 font-normal font-poppins mobile:text-[16px] tablet:text-[18px] text-[#000]">
          <template v-if="$route.name === 'purchases'">Review all the plans you’ve subscribed to, along with their
            details and status</template>
          <template v-else-if="$route.name === 'paymentMethod'">Manage your saved cards. Your default card is used for
            renewals.</template>
          <template v-else-if="$route.name === 'paymentTransaction'">View all payments made for purchases and
            renewals.</template>
          <template v-else>
            <span class="mb-0 font-normal font-poppins mobile:text-[16px] tablet:text-[18px] text-[#000]">{{
              getText() }}</span>
          </template>
        </p>
      </div>
      <!-- <div class="laptop:text-right mobile:text-center hidden" v-if="isShowProtectionPlanNumber">
        <p class="mb-0 font-normal font-roboto mobile:text-base desktop:text-lg text-[#666666]">Protection Plan
          Questions
          Call</p>
        <a href="tel:+18338882398"
          class="mb-0 font-bold font-roboto mobile:text-lg laptop:text-xl largeDesktop:text-2xl no-underline text-[#A084E8]">
          (833) 888-2398
        </a>
      </div> -->
      <div v-if="$route.name == 'commisions'"
        class="flex justify-center tablet:justify-end gap-[10px] laptop:text-right mobile:text-center z-10">
        <div
          class="px-[8px] tablet:px-[15px] py-[10px] flex items-center justify-start gap-[10px] tablet:gap-[15px] min-w-[180px] largeDesktop:min-w-[210px] rounded-[10px] shadow-[0_0_10px_0_#00000026] bg-[#fff]">
          <p class="m-0 text-[40px] laptop:text-[50px] font-roboto font-bold leading-tight text-[#F39C12]">
            $
          </p>
          <div>
            <p class="m-0 text-[14px] font-roboto text-left text-[#F39C12]">Total Pending Amount</p>
            <h2
              class="m-0 mobile:text-[20px] laptop:text-[24px] largeDesktop:text-[30px] font-roboto font-bold text-left text-[#333333]">
              ${{ $helper.formatAmountMode(this.comissionSummary?.pending_amount ?? 0, 1) }}.<span
                class="text-[16px] laptop:text-[20px] largeDesktop:text-[25px]">{{
                  $helper.formatAmountMode(this.comissionSummary?.pending_amount ?? 0, 2) }}</span>
            </h2>

          </div>
        </div>
        <div
          class="px-[8px] tablet:px-[15px] py-[10px] flex items-center justify-start gap-[10px] tablet:gap-[15px] min-w-[180px] largeDesktop:min-w-[210px] rounded-[10px] shadow-[0_0_10px_0_#00000026] bg-[#fff]">
          <p class="m-0 text-[40px] laptop:text-[50px] font-roboto font-bold leading-tight text-[#54B435]">
            $
          </p>
          <div>
            <p class="m-0 text-[14px] font-roboto text-left text-[#54B435]">Total Paid Amount</p>

            <h2
              class="m-0 mobile:text-[20px] laptop:text-[24px] largeDesktop:text-[30px] font-roboto font-bold text-left text-[#333333]">
              ${{ $helper.formatAmountMode(this.comissionSummary?.paid_amount ?? 0, 1) }}.<span
                class="text-[16px] laptop:text-[20px] largeDesktop:text-[25px]">{{
                  $helper.formatAmountMode(this.comissionSummary?.paid_amount ?? 0, 2) }}</span>
            </h2>
          </div>
        </div>
      </div>
      <div v-if="$route.name == 'plans'" class="flex justify-end w-full mobile:hidden laptop:flex">
        <div @click="cartModal()"
          class="transform lg:hover:scale-[1.05] active:scale-[0.98] duration-300 transition-all p-[5px] pr-[10px] rounded-full flex items-center shadow-[0_0_10px_0_#00000026] gap-[10px] w-max bg-[#fff] cursor-pointer"
          :class="{ '!cursor-not-allowed lg:hover:scale-[1]': cartCountResponse == null || !(cartCountResponse['items_count'] ?? 0 > 0) }">
          <p class="m-0 rounded-[50px] !py-[2px] !px-[10px] flex items-center w-max gap-[7px] bg-[#F5B134]"
            :class="{ '!bg-[#CCCCCC]': cartCountResponse == null || !(cartCountResponse['items_count'] ?? 0 > 0) }">
            <img src="../assets/images/cart-check-white.png" alt="" class="w-[22px] h-[22px]">
            <span class="font-poppins font-medium text-[18px] text-[#fff]">{{
              !(cartCountResponse['items_count']
                ?? 0 > 0) ? 0 : cartCountResponse?.items_count || 0 }}</span>
          </p>
          <p class="0 font-poppins text-[20px] font-medium text-[#333333]"
            :class="{ '!text-[#CCCCCC]': cartCountResponse == null || !(cartCountResponse['items_count'] ?? 0 > 0) }">
            ${{
              $helper.formatAmount(!(cartCountResponse['items_count'] ?? 0 > 0) ? 0 :
                cartCountResponse?.total_amount || 0)
            }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { Modal } from 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
export default {
  props: {
    heading: {
      type: String,
      default: 'Welcome',
    },
    text: {
      type: String,
      default: 'Taking care of your home has never been this easy',
    },
  },
  components: {
  },
  data() {
    return {
      modal: null,
      user: JSON.parse(localStorage.getItem('user')) ?? null
    };
  },

  computed: {
    ...mapGetters(["userObject", "comissionSummary", "cartCountResponse"]),

    isShowProtectionPlanNumber() {
      if (this.$route.name == 'purchases') {
        return true
      } else if (this.$route.name == 'commisions') {
        return true
      } else if (
        this.$route.name == 'plans'
      ) {
        return true
      } else {
        return false
      }
    },
  },


  watch: {
    userObject: function () {
      this.user = this.userObject
      localStorage.setItem('user', JSON.stringify(this.user))
    },

  },

  methods: {
    ...mapActions(["updateCartModalState"]),

    getText() {
      if (this.$route.name == 'purchases') {
        return 'Protection Plans - Purchase History'
      } else if (this.$route.name == 'commisions') {
        return 'Protection Plan Commissions Overview'
      } else if (
        this.$route.name == 'hvac-plan' ||
        this.$route.name == 'protections-plans' ||
        this.$route.name == 'plan' ||
        this.$route.name == 'bundleList' ||
        this.$route.name == 'plumbing-plan' ||
        this.$route.name == 'electric-plan'
      ) {
        return 'Optional NRG Protects Inc Protection Plans'
      } else if (this.$route.name == 'partnerCheckout') {
        return 'Review and complete your payment'
      } else if (this.$route.name == 'omegaListing') {
        return 'Grow your network. Track your success.'
      }
      else if (this.$route.name == 'contactus') {
        return 'Have a question? Send us a message and our team will get back to you shortly.'
      }
      else if (this.$route.name == 'faq') {
        return 'Find quick answers to common questions about your plan, coverage, and service process.'
      }
      else if (this.$route.name == 'claim') {
        return 'Use this form to submit a service claim under your protection plan.'
      }
      else if (this.$route.name == 'workOrders') {
        return 'Review your claim history, including submission dates, amounts, and current status.'
      }
      else if (this.$route.name == 'workOrdersDetail') {
        return 'Review your claim details, including submission date, claim amount, and current status.'
      }
      else {
        return 'Taking care of your home has never been this easy'
      }
    },

    getHeading() {
      if (this.$route.name == 'purchases' || this.$route.name == 'commisions') {
        return 'Protection Plans'
      } else if (
        this.$route.name == 'hvac-plan' ||
        this.$route.name == 'protections-plans' ||
        this.$route.name == 'plan' ||
        this.$route.name == 'bundleList' ||
        this.$route.name == 'plumbing-plan' ||
        this.$route.name == 'electric-plan'
      ) {
        return 'Protection Plans'
      } else if (
        this.$route.name == 'globalSearch'
      ) {
        return 'Search Results '
      } else if (
        this.$route.name == 'partnerCheckout'
      ) {
        return 'Checkout '
      } else if (
        this.$route.name == 'plans'
      ) {
        return 'MyHappyHome Protection Plans'
      }
      else if (
        this.$route.name == 'omegaListing'
      ) {
        return 'Welcome ' + (this.user ? this.user.user.full_name : '')
      }
      else if (
        this.$route.name == 'faq'
      ) {
        return 'Frequently Asked Questions'
      }
      else if (
        this.$route.name == 'contactus'
      ) {
        return 'Contact Us'
      } else if (
        this.$route.name == 'workOrders'
      ) {
        return 'Claim History'
      } else if (
        this.$route.name == 'workOrdersDetail'
      ) {
        return 'Claim Details'
      } else {
        return 'Welcome ' + (this.user ? this.user.user.full_name : '')
      }
    },

    cartModal() {
      if (this.cartCountResponse == null || !(this.cartCountResponse['items_count'] ?? 0 > 0)) return
      this.updateCartModalState(true)
    },

  },
}
</script>